import { render, staticRenderFns } from "./BaseBox.vue?vue&type=template&id=e33567b4&"
import script from "./BaseBox.vue?vue&type=script&lang=js&"
export * from "./BaseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e33567b4')) {
      api.createRecord('e33567b4', component.options)
    } else {
      api.reload('e33567b4', component.options)
    }
    module.hot.accept("./BaseBox.vue?vue&type=template&id=e33567b4&", function () {
      api.rerender('e33567b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Cards/BaseBox.vue"
export default component.exports